import React from "react";
import useCurrentAccountStore from "./AccountStore";
import AccountHook from "./AccountHook";
import shallow from "zustand/shallow";
import { useFormContext } from "react-hook-form";
import Swal from "sweetalert2";
import { saveAccountTable } from "./AccountAPI";
import history from "utils/createBrowserHistory";
import { PATHS } from "../constants/Constants";
import { useUserBhphPrivileges } from "../features/settings/subFeatures/settingsTabs/userManagement/useUserPrivileges";

export const AccountSaveButton = ({ modifyAccount }) => {
	console.log(modifyAccount);
	const privileges = useUserBhphPrivileges();
	const p = privileges();
	const hasPermission = p.editAccount;
	const { account } = useCurrentAccountStore(
		(state) => ({
			account: state.account,
		}),
		shallow
	);
	const save = AccountHook();
	//console.log(account);
	const saveData = async () => {
		if (account.buyerRecNum === null) {
			await Swal.fire(" Please select a customer first", "error");
			return;
		}
		try {
			await save();
			if (modifyAccount) {
				console.log(modifyAccount);
				saveAccountTable(modifyAccount).then(
					(response) => {
						console.log(response);
						history.push(PATHS.ACCT_DETAIL, {
							acctID: modifyAccount.id,
						});
					},

					(err) => {
						console.log(err);
						if (!err.isGeneralError) {
							showApiError(err, saveFailAlert);
						}
					}
				);
			}
		} catch (err) {
			console.error("Error saving account:", err);
			if (!err.isGeneralError) {
				showApiError(err, saveFailAlert);
			}
		}
	};
	const methods = useFormContext();
	return (
		<>
			<div
				className="btn btn-success float-button"
				onClick={methods.handleSubmit(saveData, (err) => {
					console.log(err);
				})}
				disabled={!hasPermission}
				//				onClick={saveData}
			>
				<i className="nc-icon nc-check-2"></i>&nbsp;
				{account.id != null ? "Update " : "Generate "} Account
			</div>
		</>
	);
};

export default AccountSaveButton;
